import { useTranslation } from "react-i18next";

export default function Input(props){
    const { t } = useTranslation();
    return(
        <div className="input-block-admin">
            <label>{props.label}:  </label>
            {props.type=='textarea' ? 
            <textarea id={props.id} onKeyDown={props.onKeyDown} name={props.name} value={props.value} onChange={props.inputChanged}/>
            :
            <input id={props.id} onKeyDown={props.onKeyDown} name={props.name} value={props.value} onChange={props.inputChanged}/>
            }
            {props.buttonAction != null ?
            <div onClick={()=>props.buttonAction(props.id,props.value)} className="add-button">{t('Ajouter')}</div>
            :""}
        </div>
    )
}